import Vue from 'vue'
import VueI18n from 'vue-i18n'

Vue.use(VueI18n)

const messages = {
    zh: {
        header: {
            home: '首页',
            aiApp: 'AI应用',
            customDev: '定制开发',
            about: '联系我们',
            trialCenter: '试用中心',
            login: '注册登录'
        },
        home: {
            title: '驱动未来业务',
            subtitle: '以AI重塑企业效能',
            description: '提供全定制化的AI智能体、企业运营系统与专属大模型训练，助您打破业务瓶颈，实现真正的数字化转型。'
        },
        footer: {
            siteMap: '网站地图',
            legalInfo: '法律信息',
            businessConsult: '业务咨询',
            contactUs: '联系我们',
            termsOfUse: '使用条款',
            privacyPolicy: '隐私政策',
            serviceAgreement: '服务协议',
            phone: '电话',
            email: '邮箱',
            address: '地址：辽宁省丹东市元宝区',
            wechat: '企业微信',
            dingtalk: '钉钉客服',
            copyright: '版权所有 © 2026 丹东恒一智行软件信息技术服务有限公司',
            securityNotice: '如果您发现我们的网站、业务系统存在安全漏洞，欢迎将漏洞信息发送给我们 邮箱地址：'
        }
    },
    en: {
        header: {
            home: 'Home',
            aiApp: 'AI Application',
            customDev: 'Custom Development',
            about: 'About.vue Us',
            trialCenter: 'Trial Center',
            login: 'Register/Login'
        },
        home: {
            title: 'Drive Future Business',
            subtitle: 'Reshape Enterprise Efficiency with AI',
            description: 'Provide fully customized AI agents, enterprise operation systems and exclusive large model training to help you break through business bottlenecks and achieve true digital transformation.'
        },
        footer: {
            siteMap: 'Site Map',
            legalInfo: 'Legal Information',
            businessConsult: 'Business Consultation',
            contactUs: 'Contact Us',
            termsOfUse: 'Terms of Use',
            privacyPolicy: 'Privacy Policy',
            serviceAgreement: 'Service Agreement',
            phone: 'Phone',
            email: 'Email',
            address: 'Address：No. 44 Renzhongqian Road, Yuandao District, Dandong City',
            wechat: 'Enterprise WeChat',
            dingtalk: 'DingTalk',
            copyright: 'Copyright © 2026 Dandong Hengyi Zhixing Software Information Technology Service Co., Ltd.',
            securityNotice: 'If you find security vulnerabilities in our website or business system, please send the vulnerability information to us. Email: '
        }
    }
}

const i18n = new VueI18n({
    locale: localStorage.getItem('lang') || 'zh',
    fallbackLocale: 'zh',
    messages
})

export default i18n
